module.exports = __webpack_public_path__ + "static/media/google.55f611a0.jpg";